import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export interface DeleteConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Shared confirm-delete dialog (matches Staff / Hub delete UX). */
const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  title = "Confirm Delete",
  message,
  confirmLabel = "Yes, Delete",
  loading = false,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="delete-dialog-title"
    aria-describedby="delete-dialog-description"
  >
    <DialogTitle id="delete-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="delete-dialog-description">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading} sx={{ color: "rgba(13, 44, 90, 1)" }}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        disabled={loading}
        variant="contained"
        sx={{
          backgroundColor: "rgba(197, 0, 0, 1)",
          "&:hover": { backgroundColor: "rgba(197, 0, 0, 0.8)" },
        }}
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmDialog;
